import AssetStructure from './AssetStructure'

export default AssetStructure
